import type {FancyTextEffect} from '@Libraries/fancy-text-library';
import type {FontData} from '@Libraries/font-library';

export type FancyTextListType = FancyTextFontStorage | FancyTextStyleStorage;

interface BaseFancyTextListStorage {
  type: FancyTextType;
}

interface FancyTextFontStorage extends BaseFancyTextListStorage {
  type: FancyTextType.FONT;
  fancyTextFonts: Array<FontData>;
}

interface FancyTextStyleStorage extends BaseFancyTextListStorage {
  type: FancyTextType.STYLE;
  fancyTextStyles: Array<FancyTextEffect>;
}

export enum FancyTextType {
  FONT = 'font',
  STYLE = 'style',
}
